
































import { Component, Vue } from 'vue-property-decorator'
import ProductList from '@/components/ProductList/index.vue'
import Tabs from '@/components/Tabs/index.vue'
// import SearchInput from '@/components/SearchInput/index.vue'
import CityIndexSearchBox from '@/components/CityIndexSearchBox/index.vue'
import { productList } from '@/api/product'
import { custProductTypies } from '@/api/com'

@Component({
  name: 'BusinessProd',
  components: {
    ProductList,
    Tabs,
    // SearchInput
    CityIndexSearchBox
  }
})
export default class BusinessProd extends Vue {
  private loading = false

  private tabList = [
    {
      name: '发布的产品',
      id: 1
    },
    {
      name: '串货的产品',
      id: 2
    }
  ]

  // 产品分类初始数据
  private productClassList: any[] = []

  private list = []

  // 查询类型（1-发布的产品 2-串货的产品）
  private id = 1

  private page = 1

  private resultNum = 10

  private sizeAll = 0

  private keywords = ''

  private treeId: number | string = ''

  private changeTabItem (id) {
    this.id = id
    this.getProductList(true)
  }

  // 翻页
  private currentChange (page) {
    this.page = page
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
    this.getProductList()
  }

  private handleSearch () {
    // this.keywords = key
    this.getProductList(true)
  }

  private getProductList (autoCount?: boolean) {
    this.loading = true
    const treeId = this.treeId === 99 ? '' : this.treeId
    const params = {
      autoCount: autoCount || false,
      type: this.id,
      page: this.page,
      resultNum: this.resultNum,
      keywords: this.keywords,
      treeId: treeId
    }
    productList(params)
      .then(res => {
        this.loading = false
        if (res) {
          if (res.sizeAll) this.sizeAll = res.sizeAll
          this.list = res.results || []
        }
      }).catch(() => {
        this.loading = false
      })
  }

  // 获取产品类型-分类 treeId
  getCustProductTypies ():void {
    custProductTypies()
      .then((res: any) => {
        if (res) {
          const arr: any[] = res || []
          arr.unshift({
            id: 99,
            name: '全部'
          })
          this.productClassList = arr
        }
      })
  }

  changeType (item): void {
    this.treeId = item
    this.getProductList(true)
  }

  mounted (): void {
    this.getCustProductTypies()
    this.getProductList(true)
  }
}
